import { state } from '@angular/animations';
import { createReducer, on } from '@ngrx/store';
import { 
  edit, 
  create, 
  reset, 
  loadSeoList, 
  loadSeoListSucess, clearSeoList, rankChangeQuad, selectProposalQuad, updateQuadListFromRecuse,
  loadQuadListSucess, clearQuadList, loadQuadList, unSelectQuad, editQuadOECIF, editQuadOEPF } from './quadList.actions';
import { selectedQuad } from './quadList.selector';


export interface SeoState{
  itemList: any[],
  status: string | 'pending' | 'loading' | 'success' | 'error',
  error: string | null,
}

export interface QuadState{
  itemList: any[],
  status: string | 'pending' | 'loading' | 'success' | 'error',
  error: string | null,
  selectedQuadUUID: string | null | any
}

// export const initialQuadState: QuadState = {
//   itemList: [],
//   status: 'pending',
//   error: null,
// };

export interface startState{
  QuadState: QuadState
}

export const initialState: QuadState = {
    itemList: [],
    status: 'pending',
    error: null,
    selectedQuadUUID: null
};

export const quadListReducer = createReducer(
  initialState,
  on(loadQuadListSucess, (state, { quadList }) => {
    let newState =  ({
        ...state,
        status: 'success',
        itemList: quadList
    })
    return newState
  }),
  on(updateQuadListFromRecuse, (state, { quadList }) =>{
    let newState =  ({
      ...state,
      status: 'success',
      itemList: quadList
    })
    return newState
  }),
  on(rankChangeQuad, (state, {rankInfo})=> {
    let existingList = [...state.itemList]

    // function arraymove(arr, fromIndex, toIndex) 
    let fromIndex = rankInfo.previousIndex
    let toIndex = rankInfo.currentIndex
    let element = existingList[fromIndex];
    existingList.splice(fromIndex, 1);
    existingList.splice(toIndex, 0, element);
    let newList: any[] = []
    existingList.forEach(({...doc}, index)=>{
      doc.rank = index+1
      newList.push(doc)
    })

    return ({
      ...state,
      itemList: newList,
      status: 'success'
    })
  }),
  on(loadQuadList, (state)=> {
    return ({
      ...state,
      status: 'loading'
    })
  }),
  on(clearQuadList, (state)=> {
    return ({
      ...state,
      status: 'success',
      itemList: []
    })
  }),
  on(unSelectQuad, (state)=> {
    return ({
      ...state,
      status: 'success',
      ...state.itemList,
      selectedQuadUUID: null
    })
  }),
  on(editQuadOEPF, (state, { listItem })=> {

    let newState = ({
      ...state,
      itemList: [...state.itemList].map(proposal=>({...proposal})).map((newProposal, localIndex)=>{

        let localEdit = newProposal
        if(listItem.id === localEdit.uuid)
        {
          //Update the formStatus
          let newQuad = ({
            quad_questions: {
              ...listItem,
              formStatus: listItem.formStatus
            }
          })
          localEdit.quad_questions = newQuad.quad_questions
        }
        return localEdit
      }),
      selectedQuad: [...state.itemList].map(proposal=>({...proposal})).map((newProposal, localIndex)=>{
        let localEdit = newProposal
        if(listItem.id === localEdit.uuid)
        {
          //Update the formStatus
          let newQuad = ({
            quad_questions: {
              ...listItem,
              formStatus: listItem.formStatus
            }
          })
          localEdit.quad_questions = newQuad.quad_questions
        }
        return localEdit
      })
    })
    return newState
  }),

  on(editQuadOECIF, (state, { listItem })=> {
    let newState = ({
      ...state,
      itemList: [...state.itemList].map(proposal=>({...proposal})).map((newProposal, localIndex)=>{
        let localEdit = newProposal
        if(listItem.id === localEdit.uuid)
        {
          //Update the formStatus
          let newQuad = ({
            quad_questions: {
              ...listItem,
              formStatus: listItem.formStatus
            }
          })
          localEdit.quad_questions = newQuad.quad_questions
        }
        return localEdit
      }),
      selectedQuad: [...state.itemList].map(proposal=>({...proposal})).map((newProposal, localIndex)=>{

        let localEdit = newProposal
        if(listItem.id === localEdit.uuid)
        {
          //Update the formStatus
          let newQuad = ({
            quad_questions: {
              ...listItem,
              formStatus: listItem.formStatus
            }
          })
          localEdit.quad_questions = newQuad.quad_questions
        }
        return localEdit
      })
    })
    return newState
  }),
  on(selectProposalQuad, (state, { propUUID })=> {
    let filterObj = state.itemList.findIndex((item)=> item.uuid == propUUID)
    let newState =  ({
      ...state,
      selectedQuadUUID: propUUID,
      itemList: [...state.itemList].map(proposal=>({...proposal})).map((newProposal, localIndex)=>{
        let localEdit = newProposal
        if(localEdit.uuid === propUUID.uuid){
          localEdit['selected'] = true
        }
        else{
          localEdit['selected'] = false
        }
        return localEdit
      })
    })
    return newState
  }),
  on(edit, (state, { listItem })=> {
    let filterObj = state.itemList.findIndex((item)=> item.uuid == listItem.id)
    return ({
      ...state,
      itemList: [...state.itemList].map(item=>({...item})).map((item2, localIndex)=>{
        if(localIndex === filterObj)
        {
          let localEdit = item2
          localEdit['supl_fund'] = listItem.fundingControl
          localEdit['supl_score'] = listItem.scoreControl
          localEdit['supl_formStatus'] = listItem.formStatus
          localEdit['supl_comment'] = listItem.comment
          return localEdit
        }
        else{
          return item2
        }
      }),
      status: 'success'
    })
  })
  // on(create, (state) => {
  //   return []
  // }),
  // on(reset, (state) => [])
);